import React, {Component} from 'react';
import {connect} from 'react-redux';
import {sumBy} from 'lodash';
import {Card, Tab, Button} from 'semantic-ui-react';
import {maxSizeEachFileInMegaBytes, maxSizeAllFilesInMegaBytes} from '../../../common/constants/ftr';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import GeneralInformation from './tabs/generalInformation';
import Attachments from './tabs/attachments';

const PANES_INDICES = {
  'GENERAL_INFORMATION': 0,
  'ATTACHMENTS': 1,
};

const panes = [
  {'menuItem': 'Información General'},
  {'menuItem': 'Adjuntos'},
];

const maxSizeEachFileInBytes = maxSizeEachFileInMegaBytes * 1000 * 1024;
const maxSizeAllFilesInBytes = maxSizeAllFilesInMegaBytes * 1000 * 1024;

class TemplateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeTabIndex': 0,
    };
    this.onNewForm = this.onNewForm.bind(this);
    this.changeTabIndex = this.changeTabIndex.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.FormsSkrManage, scopes.Create)) {
      this.props.push(paths.AccessDenied);
    }
    this.getFormAndResponseData();
  }

  getFormAndResponseData() {
    const {actionType, id, dealerId, user} = this.props;
    this.props.clearForm();

    this.setState({'activeTabIndex': 0});

    if (user) {
      this.props.setGeneralInfo('user', user);
    }
    if (dealerId) {
      this.props.fetchDealer(dealerId);
      this.props.fetchAgenciesByDealer({dealerId});
    }
    if (actionType === 'ver') {
      this.props.fetchFormResponse(id, actionType, 'S');
    }
  }

  componentDidUpdate(prevProps) {
    const {actionType, formOrResponseId, saved, id} = this.props;

    if (prevProps.actionType !== actionType) {
      this.getFormAndResponseData();
      return;
    }

    if (saved && prevProps.saved !== saved) {
      this.props.changeSavedValue(false);
      if (actionType !== 'ver') {
        this.props.push(`/formulario-skr/ver/${formOrResponseId}`);
        this.setState({'activeTabIndex': 0});
        return;
      }
      this.props.fetchFormResponse(id, actionType, 'S');
    }
  }

  onNewForm() {
    this.props.push(paths.SkrFormTemplateCreate);
  }

  validateFieldsRequiredInGeneralInformation() {
    const {actionType, generalInfo} = this.props;
    const isEditMode = actionType !== 'ver';

    if (
      isEditMode &&
      (!generalInfo.chassis ||
        !generalInfo.mileageMeasurement ||
        !generalInfo.mileage)
    ) {
      this.props.addMessageBoxError('Debe llenar todos los campos requeridos');
      return false;
    }
    return true;
  }

  validateFieldsRequiredInForm() {
    const {actionType, answers} = this.props;
    const isEditMode = actionType !== 'ver';

    if (isEditMode && (!answers.cause_of_the_problem || !answers.title)) {
      this.props.addMessageBoxError('Debe llenar todos los campos requeridos');
      return false;
    }
    return true;
  }

  validateAttachmentsSize() {
    const {attachments} = this.props;
    const totalSize = sumBy(attachments, 'size');

    if (totalSize > maxSizeAllFilesInBytes) {
      this.props.addMessageBoxError(
        'Verifique el tamaño de los archivos adjuntos, excede el tamaño máximo permitido'
      );
      return false;
    }
    return true;
  }

  isValidForm() {
    return (
      this.validateFieldsRequiredInGeneralInformation() &&
      this.validateFieldsRequiredInForm() &&
      this.validateAttachmentsSize()
    );
  }

  processFiles() {
    const {attachments} = this.props;

    const formData = new FormData();
    attachments.forEach((element) => {
      if (element.size > maxSizeEachFileInBytes) {
        return;
      }
      formData.append('file', element);
    });
    return formData;
  }

  onSaveForm(status) {
    const {generalInfo, answers} = this.props;

    const formData = this.processFiles();
    formData.append('type', 'SKR');
    formData.append('status', status);
    formData.append('generalInfo', JSON.stringify(generalInfo));
    formData.append('answers', JSON.stringify(answers));

    this.props.saveForm(formData, false);
  }

  onSaveClick(status) {
    if (!this.isValidForm()) {
      return;
    }
    this.onSaveForm(status);
  }

  isFieldsRequiredFilled(currentTab) {
    if (currentTab === PANES_INDICES.GENERAL_INFORMATION) {
      const isValidGeneralInfo =
        this.validateFieldsRequiredInGeneralInformation();
      const isValidForm = this.validateFieldsRequiredInForm();
      return isValidGeneralInfo && isValidForm;
    }
    return true;
  }

  changeTabIndex(event, data) {
    const currentTab = data.defaultActiveIndex;
    const isFieldsRequiredFilled = this.isFieldsRequiredFilled(currentTab);
    if (!isFieldsRequiredFilled) {
      return;
    }

    this.setState({'activeTabIndex': data.activeIndex});
  }

  renderPanesContent() {
    const {activeTabIndex} = this.state;
    const {actionType, status} = this.props;
    const isDisplayMode = actionType === 'ver' || status === 'published';

    switch (activeTabIndex) {
      default:
      case PANES_INDICES.GENERAL_INFORMATION:
        return <GeneralInformation isDisplayMode={isDisplayMode} />;
      case PANES_INDICES.ATTACHMENTS:
        return <Attachments isDisplayMode={isDisplayMode} />;
    }
  }

  renderButtons() {
    const {actionType, loading, saving} = this.props;
    if (actionType === 'ver') {
      return (
        <div>
          <Button
            primary
            type='submit'
            className='toyota-primary'
            disabled={loading}
            onClick={this.onNewForm}
          >
            Nuevo
          </Button>
        </div>
      );
    }
    return (
      <Button
        primary
        type='submit'
        className='toyota-primary'
        disabled={loading || saving}
        onClick={() => this.onSaveClick('published')}
      >
        Guardar
      </Button>
    );
  }

  render() {
    const {activeTabIndex} = this.state;

    return (
      <div className='icc-form'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Formulario: SKR</h2>
              <div className='title-bar-actions'>{this.renderButtons()}</div>
            </div>
          </div>

          <Tab
            menu={{'secondary': true, 'pointing': true, 'color': 'red'}}
            panes={panes}
            activeIndex={activeTabIndex}
            onTabChange={this.changeTabIndex}
          />
        </Card>

        {this.renderPanesContent()}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {actionType, id} = ownProps.params;
  return {
    id,
    actionType,
    'formOrResponseId': state.templateSKR.id,
    'dealerId': state.session.dealerId,
    'user': state.session.user,
    'loading': state.templateSKR.loading,
    'saving': state.templateSKR.saving,
    'saved': state.templateSKR.saved,
    'status': state.templateSKR.status,
    'generalInfo': state.templateSKR.generalInfo,
    'answers': state.templateSKR.answers,
    'attachments': state.templateSKR.attachments,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
  };
};

const {
  withRouter,
  clearForm,
  setGeneralInfo,
  fetchDealer,
  fetchAgenciesByDealer,
  saveForm,
  fetchFormResponse,
  addMessageBoxError,
  changeSavedValue,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  clearForm,
  setGeneralInfo,
  fetchDealer,
  fetchAgenciesByDealer,
  saveForm,
  fetchFormResponse,
  addMessageBoxError,
  changeSavedValue,
})(TemplateForm));
